// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"db3c385f","257":"95e1ac83","455":"ec0640b8","977":"c7d97113"}[chunkId] + ".chunk.js";
};